import { flow, types, getEnv, getSnapshot } from 'mobx-state-tree'

import { AdminTeamModel, JurisdictionModel, AdminTeamAthletesModel } from './'

const AdminTeams = types
  .model('AdminTeamsModel', {
    content: types.optional(types.array(AdminTeamModel), []),
    page: types.optional(types.number, 0),
    size: types.optional(types.number, 0),
    totalPages: types.optional(types.number, 1),
    sportType: types.optional(types.string, ''),
    name: types.optional(types.string, ''),
    jurisdictions: types.optional(types.array(JurisdictionModel), []),
    athletesIds: types.optional(types.array(types.number), []),
    teamAthletes: types.optional(AdminTeamAthletesModel, {}),
  })
  .actions((self) => {
    const {
      services: { adminTeamsService, adminAthletesService },
    } = getEnv(self)

    const loadTeamsGlobal = function* ({ name, sportType, page, size, sort }) {
      const serverMaper = {
        id: 'id',
        teamName: 'name',
        sport: 'sport',
        league: 'league',
        'jurisdiction.logo': 'jurisdiction',
        teamWebsite: 'website',
      }
      let sortValue = sort.length === 1 ? sort[0] : undefined
      if (sortValue) {
        sortValue = `${serverMaper[sortValue.id]},${
          sortValue.desc ? 'asc' : 'desc'
        }`
      }

      const response = yield adminTeamsService.queryTeams({
        teamName: name,
        sportType,
        page,
        size,
        sort: sortValue,
      })

      self.content = response.content
      self.totalPages = response.totalPages
      self.page = response.pageable.pageNumber
      self.size = response.pageable.pageSize
      self.name = name || ''
      self.sportType = sportType || ''
      return getSnapshot(self)
    }

    const loadJurisdictionList = function* () {
      const jurisdictionRequest = yield adminTeamsService.getJurisdictionList()
      self.jurisdictions = jurisdictionRequest.content
      return getSnapshot(self)
    }

    const loadTeamById = function* (id) {
      const response = yield adminTeamsService.getTeamById(id)
      self.athletesIds = response.athletesIds
      return getSnapshot(self)
    }

    const updateTeamAthletesIds = (athletesId) => {
      self.athletesIds = athletesId
      return getSnapshot(self)
    }

    const loadTeamAthletes = function* ({ name, sportType, page, size }) {
      const response = yield adminAthletesService.queryAthletes({
        name,
        sportType,
        page,
        size,
      })

      const teamAthletesContent = response.content.map((athlete) => {
        return {
          ...athlete,
          isAddedToTeam: self.athletesIds.includes(athlete.id),
        }
      })

      self.teamAthletes.content = teamAthletesContent
      self.teamAthletes.totalPages = response.totalPages
      self.teamAthletes.page = response.pageable.pageNumber
      self.teamAthletes.size = response.pageable.pageSize
      self.teamAthletes.name = name || ''
      self.teamAthletes.sportType = sportType || ''
      return getSnapshot(self.teamAthletes)
    }

    const teamAdded = () => {
      self.page = self.totalPages - 1
    }

    loadJurisdictionList()

    return {
      loadTeams: flow(({ name, sportType, page, size, sort }) =>
        loadTeamsGlobal({ name, sportType, page, size, sort })
      ),
      loadJurisdictionListFromStore: flow(() => loadJurisdictionList()),
      onTeamAdded: teamAdded,
      loadTeamById: flow((teamId) => loadTeamById(teamId)),
      loadTeamAthletes: flow(({ name, sportType, page, size }) =>
        loadTeamAthletes({ name, sportType, page, size })
      ),
      updateTeamAthletesIds,
    }
  })

export const AdminTeamsRoot = types.model('AdminTeams', {
  adminTeams: types.optional(AdminTeams, {}),
})
